import { StoreState } from '@/redux/types';
import { getDiscountsSupportedKey } from './getDiscountsSupportedKey';

export const getDiscountsSupported = (
  state: StoreState,
  contextId: string,
  productTypeId: string
) => state.discounts.supported[getDiscountsSupportedKey(contextId, productTypeId)];
